<template>
  <div class="my">
    <van-nav-bar title="我的" @click-left="$router.back()"></van-nav-bar>
    <van-row class="topMY">
      <van-col class="left" span="6">
        <van-image
          :src="require('../assets/wodedangxuan.png')"
          height="60px"
          round
          width="60px"
        />
      </van-col>
      <van-col class="right" span="18">
        <h2>{{ name }}</h2>
        <p>&nbsp;</p>
      </van-col>
    </van-row>
    <i class="line"></i>
    <van-cell-group class="user-group" route>
      <div>
        <!--        <img :src="require('../assets/login/my2.png')" alt="" />-->
        <van-cell
          is-link
          name="/ChangePassword"
          title="修改密码"
          to="/ChangePassword"
        />
      </div>
      <div>
        <!--        <img :src="require('../assets/login/my1.png')" alt="" />-->
        <van-cell is-link title="退出登录" @click="Logout" />
      </div>
      <!-- <van-cell icon="setting-o" @click="toWxlogin" title="微信登录" is-link /> -->
    </van-cell-group>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { userInfo } from "@/api/user.js";
import wx from "@/util/wx.js";

export default {
  name: "my",
  data() {
    return {
      userId: window.localStorage.getItem("userId"),
      name: "",
    };
  },
  created() {
    this.getUser();
  },

  methods: {
    ...mapMutations(["delUser"]),
    toWxlogin() {
      // 回调后台地址cccccccc
      // var url = window.encodeURIComponent('http://b379-39-71-229-118.ngrok.io/sansint-buildauto/weixin/apiCallBack')
      // 回调前台地址
      var url = window.encodeURIComponent(wx.backUrl);
      window.c.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        wx.appId +
        "&redirect_uri=" +
        url +
        "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      // eslint-disable-next-line no-undef
    },
    // 退出登录
    Logout() {
      this.$dialog
        .confirm({
          title: "退出登录",
          message: "确定要退出吗？",
        })
        .then(() => {
          this.delUser();
          // replace 替换当前的历史记录，产生新的记录。不会追加
          this.$router.push("/login");
        });
    },
    getUser() {
      userInfo(this.userId).then((res) => {
        this.name = res.data.data.name;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.topMY {
  height: 120px;
  margin-top: 47px;
  background: url(../assets/login/my.png) no-repeat;
  background-size: 100% 150px;
}

&-group {
  margin-bottom: 15px;
}

.van-cell__title {
  padding-left: 20px;
}

.van-cell {
  text-align: left;
}

.left {
  padding-left: 10px;
  padding-top: 5px;
  margin-top: 30px;
}

.right {
  margin-top: 30px;
  text-align: left;

  h2 {
    font-size: 18px;
    color: #fff;
  }

  p {
    font-size: 14px;
    color: #fff;
  }
}

.user-group {
  & > div {
    position: relative;

    &:first-child:before {
      content: "";
      position: absolute;
      left: 2%;
      top: 28%;
      width: 20px;
      height: 20px;
      z-index: 1;
      background: url("../assets/login/my2.png") no-repeat;
      background-size: cover;
    }

    &:last-child:before {
      content: "";
      position: absolute;
      left: 2%;
      top: 28%;
      width: 20px;
      height: 20px;
      z-index: 1;
      background: url("../assets/login/my1.png") no-repeat;
      background-size: cover;
    }
  }
}
</style>
